import React from 'react';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { useT } from '../i18n/LanguageContext';

export default function LanguageSwitcher() {
  const { lang, setLang, languages } = useT();
  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/5 hover:bg-white/10 border border-white/15 text-white text-xs font-semibold tracking-wider transition-colors"
          aria-label="Change language"
        >
          <Globe className="w-3.5 h-3.5" />
          <span>{current.flag}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-neutral-900 border-neutral-700 text-neutral-100 min-w-[160px]">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            className={`cursor-pointer focus:bg-[#c92a2a] focus:text-white ${l.code === lang ? 'text-[#ff6b6b]' : ''}`}
          >
            <span className="font-mono text-[11px] w-7 text-neutral-400">{l.flag}</span>
            <span className="font-medium">{l.label}</span>
            {l.code === lang && <span className="ml-auto text-xs">✓</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
